import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { getEnabledFlagList } from '../helpers';
import { useDeepEqualMemo } from '@wix/da-hooks/pkg/useDeepEqualMemo';
export function useEnabledFlagList() {
    const flags = useContext(FlagContext);
    const flagList = useDeepEqualMemo(getEnabledFlagList(flags));
    return flagList;
}
